import React from 'react';
import { HiBadgeCheck } from "react-icons/hi";

const FiltroMarcasDinamicas = ({ marcas, marcaSeleccionada, onMarcaSelect, query }) => {
    if (marcas.length === 0) return null;

    return (
        <div style={{ marginBottom: '2em' }}>
            <h4 style={{ marginBottom: '1em' }}>Filtro por marca</h4>
            {marcas.map((marca, index) => (
                <div 
                    key={index} 
                    style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        marginBottom: '1.5em', 
                        cursor: 'pointer',
                        padding: '0.5em',
                        backgroundColor: marcaSeleccionada === marca.Descripcion ? '#e3f2fd' : 'transparent',
                        borderRadius: '4px',
                        border: marcaSeleccionada === marca.Descripcion ? '1px solid #2196f3' : '1px solid transparent',
                        transition: 'all 0.2s ease'
                    }}
                    onClick={() => onMarcaSelect(marca.Descripcion)}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = marcaSeleccionada === marca.Descripcion ? '#e3f2fd' : '#f5f5f5';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = marcaSeleccionada === marca.Descripcion ? '#e3f2fd' : 'transparent';
                    }}
                >
                    <div style={{ width: '100%' }}>
                        <h5 style={{ 
                            margin: 0, 
                            fontSize: '1em', 
                            display: 'flex', 
                            alignItems: 'center',
                            fontWeight: marcaSeleccionada === marca.Descripcion ? 'bold' : 'normal',
                            color: marcaSeleccionada === marca.Descripcion ? '#2196f3' : '#333'
                        }}>
                            {marca.Descripcion}
                            {marcaSeleccionada === marca.Descripcion ? (
                                <span style={{ marginLeft: '0.5em', color: '#4caf50', fontSize: '1.2em', fontWeight: 'bold' }}>
                                    ✓
                                </span>
                            ) : (
                                <HiBadgeCheck style={{ marginLeft: '0.2em', color: '#007bff', fontSize: '1.5em' }} />
                            )}
                        </h5>
                        
                        {marcaSeleccionada !== marca.Descripcion && (
                            <p style={{ 
                                margin: 0, 
                                fontSize: '0.85em', 
                                color: '#007bff',
                                marginTop: '0.3em',
                                textDecoration: 'underline',
                                fontWeight: '500'
                            }}>
                                Ver {marca.count} producto{marca.count !== 1 ? 's' : ''}
                            </p>
                        )}
                    </div>
                </div>
            ))}
            
            {marcaSeleccionada && (
                <div style={{ marginTop: '1em', paddingTop: '1em', borderTop: '1px solid #eee' }}>
                    <button
                        onClick={() => onMarcaSelect(null)}
                        style={{
                            background: 'none',
                            border: '1px solid #ccc',
                            color: '#666',
                            padding: '0.5em 1em',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '0.85em',
                            width: '100%',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#f5f5f5';
                            e.target.style.borderColor = '#999';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                            e.target.style.borderColor = '#ccc';
                        }}
                    >
                        🗑️ Limpiar filtro de marca
                    </button>
                </div>
            )}
        </div>
    );
};

export default FiltroMarcasDinamicas;